var map = {
	"./adventure-house/agent-8900/description_da.md": 1455,
	"./adventure-house/agent-8900/description_en.md": 97445,
	"./adventure-house/director-hallandsens-diamond/description_da.md": 23188,
	"./adventure-house/director-hallandsens-diamond/description_en.md": 75057,
	"./adventure-house/the-mad-scientist/description_da.md": 72160,
	"./adventure-house/the-mad-scientist/description_en.md": 12023,
	"./adventure-house/the-mad-scientist/review_da.md": 27209,
	"./adventure-house/the-mad-scientist/review_en.md": 17573,
	"./adventure-house/venue_da.md": 68716,
	"./adventure-house/venue_en.md": 83396,
	"./amaze/mafia/description_da.md": 59387,
	"./amaze/mafia/description_en.md": 62644,
	"./amaze/pirate-island/description_da.md": 82595,
	"./amaze/pirate-island/description_en.md": 40681,
	"./amaze/tomb/description_da.md": 18630,
	"./amaze/tomb/description_en.md": 90552,
	"./amaze/venue_da.md": 94402,
	"./amaze/venue_en.md": 23917,
	"./ballerup-gokart-and-event-center/the-kiosk/description_da.md": 39497,
	"./ballerup-gokart-and-event-center/the-kiosk/description_en.md": 94341,
	"./ballerup-gokart-and-event-center/venue_da.md": 30475,
	"./ballerup-gokart-and-event-center/venue_en.md": 24980,
	"./ballerup-gokart-and-event-center/williams-dilemma/description_da.md": 29688,
	"./ballerup-gokart-and-event-center/williams-dilemma/description_en.md": 73385,
	"./bowl-n-fun/abandoned-reactor/description_da.md": 84104,
	"./bowl-n-fun/abandoned-reactor/description_en.md": 76842,
	"./bowl-n-fun/haunted-mansion/description_da.md": 77319,
	"./bowl-n-fun/haunted-mansion/description_en.md": 6962,
	"./bowl-n-fun/hunters-lodge/description_da.md": 2802,
	"./bowl-n-fun/hunters-lodge/description_en.md": 43,
	"./bowl-n-fun/jack-the-ripper/description_da.md": 48360,
	"./bowl-n-fun/jack-the-ripper/description_en.md": 80326,
	"./bowl-n-fun/lost-city-of-atlantis/description_da.md": 85310,
	"./bowl-n-fun/lost-city-of-atlantis/description_en.md": 66847,
	"./bowl-n-fun/medieval-castle/description_da.md": 62246,
	"./bowl-n-fun/medieval-castle/description_en.md": 86685,
	"./bowl-n-fun/mission-impossible/description_da.md": 65224,
	"./bowl-n-fun/mission-impossible/description_en.md": 23395,
	"./bowl-n-fun/pirates-queen-annes-revenge/description_da.md": 74044,
	"./bowl-n-fun/pirates-queen-annes-revenge/description_en.md": 94281,
	"./bowl-n-fun/saw/description_da.md": 61344,
	"./bowl-n-fun/saw/description_en.md": 28291,
	"./bowl-n-fun/the-chocolate-factory/description_da.md": 79605,
	"./bowl-n-fun/the-chocolate-factory/description_en.md": 51516,
	"./bowl-n-fun/the-forbidden-temple-of-montezuma/description_da.md": 18345,
	"./bowl-n-fun/the-forbidden-temple-of-montezuma/description_en.md": 86100,
	"./bowl-n-fun/tutankhamuns-tomb/description_da.md": 77096,
	"./bowl-n-fun/tutankhamuns-tomb/description_en.md": 45577,
	"./bowl-n-fun/venue_da.md": 14589,
	"./bowl-n-fun/venue_en.md": 23435,
	"./bowl-n-fun/walking-death/description_da.md": 72081,
	"./bowl-n-fun/walking-death/description_en.md": 62674,
	"./brain-escape/brain-escape/description_da.md": 38334,
	"./brain-escape/brain-escape/description_en.md": 32310,
	"./brain-escape/pandoras-dream/description_da.md": 9357,
	"./brain-escape/pandoras-dream/description_en.md": 96255,
	"./brain-escape/venue_da.md": 52306,
	"./brain-escape/venue_en.md": 9109,
	"./brain-game-cph/pablo-escobar/description_da.md": 9990,
	"./brain-game-cph/pablo-escobar/description_en.md": 28114,
	"./brain-game-cph/seven/description_da.md": 85137,
	"./brain-game-cph/seven/description_en.md": 79707,
	"./brain-game-cph/seven/review_en.md": 25377,
	"./brain-game-cph/the-last-passenger/description_da.md": 15992,
	"./brain-game-cph/the-last-passenger/description_en.md": 73934,
	"./brain-game-cph/the-last-passenger/review_en.md": 89372,
	"./brain-game-cph/the-ring/description_da.md": 45020,
	"./brain-game-cph/the-ring/description_en.md": 9909,
	"./brain-game-cph/the-ring/review_en.md": 7176,
	"./brain-game-cph/venue_da.md": 70783,
	"./brain-game-cph/venue_en.md": 15487,
	"./breakout-room/basement-13/description_da.md": 88937,
	"./breakout-room/basement-13/description_en.md": 68128,
	"./breakout-room/basement-13/review_en.md": 87865,
	"./breakout-room/black-magic/description_da.md": 58289,
	"./breakout-room/black-magic/description_en.md": 34311,
	"./breakout-room/black-magic/review_en.md": 71271,
	"./breakout-room/the-jungle-mystery/description_da.md": 14029,
	"./breakout-room/the-jungle-mystery/description_en.md": 71549,
	"./breakout-room/the-time-machine/description_da.md": 97005,
	"./breakout-room/the-time-machine/description_en.md": 88914,
	"./breakout-room/the-time-machine/review_en.md": 58508,
	"./breakout-room/venue_da.md": 45899,
	"./breakout-room/venue_en.md": 58119,
	"./city-bowling-holbaek/venue_da.md": 29483,
	"./city-bowling-holbaek/venue_en.md": 10440,
	"./clockedin/the-cocktail-party-of-vlad-d/description_da.md": 46366,
	"./clockedin/the-cocktail-party-of-vlad-d/description_en.md": 31025,
	"./clockedin/the-cocktail-party-of-vlad-d/review_en.md": 26950,
	"./clockedin/the-murder-mystery-at-the-office/description_da.md": 47470,
	"./clockedin/the-murder-mystery-at-the-office/description_en.md": 71462,
	"./clockedin/the-murder-mystery-at-the-office/review_en.md": 9245,
	"./clockedin/the-mystery-of-the-secret-warehouse/description_da.md": 3517,
	"./clockedin/the-mystery-of-the-secret-warehouse/description_en.md": 80278,
	"./clockedin/the-mystery-of-the-secret-warehouse/review_en.md": 65010,
	"./clockedin/venue_da.md": 13078,
	"./clockedin/venue_en.md": 10986,
	"./countdown-escaperooms/venue_da.md": 32271,
	"./countdown-escaperooms/venue_en.md": 31157,
	"./countdown/archaeological-expedition/description_da.md": 33399,
	"./countdown/archaeological-expedition/description_en.md": 11671,
	"./countdown/the-jewel-theft/description_da.md": 45890,
	"./countdown/the-jewel-theft/description_en.md": 66362,
	"./countdown/the-slaughterhouse/description_da.md": 97712,
	"./countdown/the-slaughterhouse/description_en.md": 91104,
	"./countdown/venue_da.md": 47929,
	"./countdown/venue_en.md": 79772,
	"./down-the-rabbit-hole/korowai-a-professors-tale/description_da.md": 43920,
	"./down-the-rabbit-hole/korowai-a-professors-tale/description_en.md": 21123,
	"./down-the-rabbit-hole/venue_da.md": 94412,
	"./down-the-rabbit-hole/venue_en.md": 21423,
	"./escape-attic/the-flood/description_da.md": 51948,
	"./escape-attic/the-flood/description_en.md": 8748,
	"./escape-attic/venue_da.md": 46623,
	"./escape-attic/venue_en.md": 44478,
	"./escape-attic/zimmer-657/description_da.md": 69199,
	"./escape-attic/zimmer-657/description_en.md": 82160,
	"./escape-copenhagen/dr-evils-plan/description_da.md": 38589,
	"./escape-copenhagen/dr-evils-plan/description_en.md": 73114,
	"./escape-copenhagen/enter-the-mind/description_da.md": 74871,
	"./escape-copenhagen/enter-the-mind/description_en.md": 15979,
	"./escape-copenhagen/enter-the-mind/review_en.md": 90213,
	"./escape-copenhagen/the-psychotic-janitor/description_da.md": 63102,
	"./escape-copenhagen/the-psychotic-janitor/description_en.md": 60464,
	"./escape-copenhagen/the-rogue-general/description_da.md": 98200,
	"./escape-copenhagen/the-rogue-general/description_en.md": 12886,
	"./escape-copenhagen/the-solitary-monk/description_da.md": 94916,
	"./escape-copenhagen/the-solitary-monk/description_en.md": 24546,
	"./escape-copenhagen/the-terrorist-cell/description_da.md": 63550,
	"./escape-copenhagen/the-terrorist-cell/description_en.md": 32067,
	"./escape-copenhagen/venue_da.md": 72543,
	"./escape-copenhagen/venue_en.md": 24592,
	"./escape-copenhagen/vikings/description_da.md": 9085,
	"./escape-copenhagen/vikings/description_en.md": 91565,
	"./escape-denmark/the-puppeteers-workshop/description_da.md": 70253,
	"./escape-denmark/the-puppeteers-workshop/description_en.md": 9890,
	"./escape-denmark/trapped-in-amazonas/description_da.md": 48489,
	"./escape-denmark/trapped-in-amazonas/description_en.md": 38701,
	"./escape-denmark/venue_da.md": 61406,
	"./escape-denmark/venue_en.md": 33155,
	"./escape-factory/enigma/description_da.md": 88000,
	"./escape-factory/enigma/description_en.md": 45683,
	"./escape-factory/the-alchemist/description_da.md": 2037,
	"./escape-factory/the-alchemist/description_en.md": 82218,
	"./escape-factory/the-murder-of-colonel-fitzpatrick/description_da.md": 76584,
	"./escape-factory/the-murder-of-colonel-fitzpatrick/description_en.md": 36567,
	"./escape-factory/venue_da.md": 76595,
	"./escape-factory/venue_en.md": 85233,
	"./escape-fyn/venue_da.md": 52964,
	"./escape-fyn/venue_en.md": 1766,
	"./escape-game-odense/crime-scene/description_da.md": 91248,
	"./escape-game-odense/crime-scene/description_en.md": 9349,
	"./escape-game-odense/the-spy-room/description_da.md": 90251,
	"./escape-game-odense/the-spy-room/description_en.md": 98766,
	"./escape-game-odense/the-virus-room/description_da.md": 6383,
	"./escape-game-odense/the-virus-room/description_en.md": 1562,
	"./escape-game-odense/venue_da.md": 29068,
	"./escape-game-odense/venue_en.md": 94740,
	"./escape-games/ednas-condo/description_da.md": 35631,
	"./escape-games/ednas-condo/description_en.md": 61777,
	"./escape-games/find-felix/description_da.md": 3584,
	"./escape-games/find-felix/description_en.md": 90433,
	"./escape-games/pirate-island/description_da.md": 47935,
	"./escape-games/pirate-island/description_en.md": 96717,
	"./escape-games/santas-time-machine/description_da.md": 28843,
	"./escape-games/santas-time-machine/description_en.md": 58691,
	"./escape-games/the-hospital/description_da.md": 86337,
	"./escape-games/the-hospital/description_en.md": 16538,
	"./escape-games/the-lab/description_da.md": 96137,
	"./escape-games/the-lab/description_en.md": 23581,
	"./escape-games/the-viking-expedition/description_da.md": 23478,
	"./escape-games/the-viking-expedition/description_en.md": 91279,
	"./escape-games/venue_da.md": 25621,
	"./escape-games/venue_en.md": 73304,
	"./escape-history-house/escape-land-of-mine/description_da.md": 14613,
	"./escape-history-house/escape-land-of-mine/description_en.md": 41331,
	"./escape-history-house/escape-tirpitz/description_da.md": 63387,
	"./escape-history-house/escape-tirpitz/description_en.md": 89721,
	"./escape-history-house/illuminati-cabin/description_da.md": 66098,
	"./escape-history-house/illuminati-cabin/description_en.md": 45817,
	"./escape-history-house/venue_da.md": 38296,
	"./escape-history-house/venue_en.md": 41498,
	"./escape-room-randers/mental-hospital/description_da.md": 43738,
	"./escape-room-randers/mental-hospital/description_en.md": 67273,
	"./escape-room-randers/murder-at-the-grand-hotel/description_da.md": 93755,
	"./escape-room-randers/murder-at-the-grand-hotel/description_en.md": 21430,
	"./escape-room-randers/prison-break/description_da.md": 72627,
	"./escape-room-randers/prison-break/description_en.md": 88425,
	"./escape-room-randers/submarine/description_da.md": 3927,
	"./escape-room-randers/submarine/description_en.md": 40145,
	"./escape-room-randers/venue_da.md": 60140,
	"./escape-room-randers/venue_en.md": 88863,
	"./escape-room-roskilde/alcatraz-2.0/description_da.md": 44397,
	"./escape-room-roskilde/alcatraz-2.0/description_en.md": 33081,
	"./escape-room-roskilde/the-christmas-presents/description_da.md": 74483,
	"./escape-room-roskilde/the-christmas-presents/description_en.md": 87199,
	"./escape-room-roskilde/the-criminals-workshop/description_da.md": 73769,
	"./escape-room-roskilde/the-criminals-workshop/description_en.md": 11216,
	"./escape-room-roskilde/the-secret-vaccine/description_da.md": 28961,
	"./escape-room-roskilde/the-secret-vaccine/description_en.md": 6775,
	"./escape-room-roskilde/the-stolen-mona-lisa/description_da.md": 93214,
	"./escape-room-roskilde/the-stolen-mona-lisa/description_en.md": 66751,
	"./escape-room-roskilde/venue_da.md": 15150,
	"./escape-room-roskilde/venue_en.md": 36926,
	"./escape-room-tarm/the-dairy/description_da.md": 21226,
	"./escape-room-tarm/the-dairy/description_en.md": 75076,
	"./escape-room-tarm/the-mad-artist/description_da.md": 57026,
	"./escape-room-tarm/the-mad-artist/description_en.md": 14814,
	"./escape-room-tarm/venue_da.md": 93144,
	"./escape-room-tarm/venue_en.md": 69057,
	"./escape-room-varde/escape-room-varde/description_da.md": 21415,
	"./escape-room-varde/escape-room-varde/description_en.md": 61958,
	"./escape-room-varde/venue_da.md": 75348,
	"./escape-room-varde/venue_en.md": 83498,
	"./escape-skagen/command-bunker/description_da.md": 59106,
	"./escape-skagen/command-bunker/description_en.md": 32007,
	"./escape-skagen/harrys-hideout/description_da.md": 10514,
	"./escape-skagen/harrys-hideout/description_en.md": 64708,
	"./escape-skagen/venue_da.md": 95393,
	"./escape-skagen/venue_en.md": 60612,
	"./escape-team/live-and-let-dive/description_da.md": 39544,
	"./escape-team/live-and-let-dive/description_en.md": 60600,
	"./escape-team/venue_da.md": 17720,
	"./escape-team/venue_en.md": 37385,
	"./escape-viborg/the-jewel-heist/description_da.md": 17154,
	"./escape-viborg/the-jewel-heist/description_en.md": 90285,
	"./escape-viborg/venue_da.md": 12330,
	"./escape-viborg/venue_en.md": 24795,
	"./escape-viborg/your-worst-nightmare/description_da.md": 69157,
	"./escape-viborg/your-worst-nightmare/description_en.md": 88530,
	"./escape-zone/bomb-squad/description_da.md": 44048,
	"./escape-zone/bomb-squad/description_en.md": 44338,
	"./escape-zone/kidnapped/description_da.md": 35281,
	"./escape-zone/kidnapped/description_en.md": 92559,
	"./escape-zone/mission-impossible/description_da.md": 60069,
	"./escape-zone/mission-impossible/description_en.md": 79451,
	"./escape-zone/prison-break/description_da.md": 33134,
	"./escape-zone/prison-break/description_en.md": 53465,
	"./escape-zone/the-ring/description_da.md": 85760,
	"./escape-zone/the-ring/description_en.md": 63266,
	"./escape-zone/venue_da.md": 82501,
	"./escape-zone/venue_en.md": 11560,
	"./escapee/area-51/description_da.md": 50090,
	"./escapee/area-51/description_en.md": 47868,
	"./escapee/draculas-chamber/description_da.md": 21689,
	"./escapee/draculas-chamber/description_en.md": 41422,
	"./escapee/merlin/description_da.md": 90982,
	"./escapee/merlin/description_en.md": 84837,
	"./escapee/the-cursed-treasure/description_da.md": 6513,
	"./escapee/the-cursed-treasure/description_en.md": 67416,
	"./escapee/the-orphanage/description_da.md": 8628,
	"./escapee/the-orphanage/description_en.md": 73108,
	"./escapee/venue_da.md": 77915,
	"./escapee/venue_en.md": 57398,
	"./escapist/the-great-diamond-heist/description_da.md": 95297,
	"./escapist/the-great-diamond-heist/description_en.md": 11279,
	"./escapist/uss-triton/description_da.md": 27846,
	"./escapist/uss-triton/description_en.md": 25566,
	"./escapist/venue_da.md": 30504,
	"./escapist/venue_en.md": 90961,
	"./escapist/wanted/description_da.md": 48980,
	"./escapist/wanted/description_en.md": 82759,
	"./eventcamp-ertebjerggaard/leif-mortensens-condo/description_da.md": 745,
	"./eventcamp-ertebjerggaard/leif-mortensens-condo/description_en.md": 87609,
	"./eventcamp-ertebjerggaard/the-prison/description_da.md": 91341,
	"./eventcamp-ertebjerggaard/the-prison/description_en.md": 70711,
	"./eventcamp-ertebjerggaard/the-slaughterhouse/description_da.md": 1734,
	"./eventcamp-ertebjerggaard/the-slaughterhouse/description_en.md": 74452,
	"./eventcamp-ertebjerggaard/venue_da.md": 65135,
	"./eventcamp-ertebjerggaard/venue_en.md": 40437,
	"./fabriksevent/leif-mortensens-condo/description_da.md": 85936,
	"./fabriksevent/leif-mortensens-condo/description_en.md": 45434,
	"./fabriksevent/the-prison/description_da.md": 60005,
	"./fabriksevent/the-prison/description_en.md": 57243,
	"./fabriksevent/the-slaughterhouse/description_da.md": 73960,
	"./fabriksevent/the-slaughterhouse/description_en.md": 62703,
	"./fabriksevent/venue_da.md": 58325,
	"./fabriksevent/venue_en.md": 53007,
	"./froeslevlejrens-museum/venue_da.md": 24576,
	"./froeslevlejrens-museum/venue_en.md": 71757,
	"./funcenter/the-box/description_da.md": 4937,
	"./funcenter/the-box/description_en.md": 28350,
	"./funcenter/the-bunker/description_da.md": 59034,
	"./funcenter/the-bunker/description_en.md": 84107,
	"./funcenter/the-jungle/description_da.md": 19732,
	"./funcenter/the-jungle/description_en.md": 60813,
	"./funcenter/the-killer/description_da.md": 5621,
	"./funcenter/the-killer/description_en.md": 99013,
	"./funcenter/the-prison/description_da.md": 34833,
	"./funcenter/the-prison/description_en.md": 38473,
	"./funcenter/the-submarine/description_da.md": 4570,
	"./funcenter/the-submarine/description_en.md": 19265,
	"./funcenter/venue_da.md": 24852,
	"./funcenter/venue_en.md": 32111,
	"./garderhojfortet/venue_da.md": 85269,
	"./garderhojfortet/venue_en.md": 80176,
	"./getout/alice-out-of-wonderland/description_da.md": 63726,
	"./getout/alice-out-of-wonderland/description_en.md": 83092,
	"./getout/corrupt/description_da.md": 11811,
	"./getout/corrupt/description_en.md": 92049,
	"./getout/the-cabin/description_da.md": 25569,
	"./getout/the-cabin/description_en.md": 90610,
	"./getout/the-pirate/description_da.md": 89907,
	"./getout/the-pirate/description_en.md": 12761,
	"./getout/venue_da.md": 5162,
	"./getout/venue_en.md": 86374,
	"./golf-and-fun-park/venue_da.md": 30572,
	"./golf-and-fun-park/venue_en.md": 80215,
	"./goodlock/the-gold-heist/description_da.md": 50779,
	"./goodlock/the-gold-heist/description_en.md": 90162,
	"./goodlock/the-terrorist/description_da.md": 44639,
	"./goodlock/the-terrorist/description_en.md": 18202,
	"./goodlock/venue_da.md": 72060,
	"./goodlock/venue_en.md": 87400,
	"./goodlock/virus/description_da.md": 40777,
	"./goodlock/virus/description_en.md": 68353,
	"./great-escape/the-cannibal/description_da.md": 95227,
	"./great-escape/the-cannibal/description_en.md": 45233,
	"./great-escape/the-room/description_da.md": 21741,
	"./great-escape/the-room/description_en.md": 34012,
	"./great-escape/the-wizard/description_da.md": 98430,
	"./great-escape/the-wizard/description_en.md": 3673,
	"./great-escape/venue_da.md": 9309,
	"./great-escape/venue_en.md": 10840,
	"./holbaek-museum/mutiny-on-the-good-intention/description_da.md": 62622,
	"./holbaek-museum/mutiny-on-the-good-intention/description_en.md": 36581,
	"./holbaek-museum/venue_da.md": 95674,
	"./holbaek-museum/venue_en.md": 67149,
	"./hotel-trapped/room-13/description_da.md": 24835,
	"./hotel-trapped/room-13/description_en.md": 24020,
	"./hotel-trapped/room-7/description_da.md": 59068,
	"./hotel-trapped/room-7/description_en.md": 89638,
	"./hotel-trapped/the-murder-of-elinor/description_da.md": 54768,
	"./hotel-trapped/the-murder-of-elinor/description_en.md": 8579,
	"./hotel-trapped/venue_da.md": 46998,
	"./hotel-trapped/venue_en.md": 71671,
	"./koldkrigsmuseum-stevnsfort/escape-room-bunker/description_da.md": 56032,
	"./koldkrigsmuseum-stevnsfort/escape-room-bunker/description_en.md": 44611,
	"./koldkrigsmuseum-stevnsfort/venue_da.md": 56729,
	"./koldkrigsmuseum-stevnsfort/venue_en.md": 52776,
	"./locked/chernobyl/description_da.md": 38008,
	"./locked/chernobyl/description_en.md": 89071,
	"./locked/crime-scene/description_da.md": 89828,
	"./locked/crime-scene/description_en.md": 26095,
	"./locked/jigsaw/description_da.md": 95634,
	"./locked/jigsaw/description_en.md": 428,
	"./locked/kidnapped/description_da.md": 57813,
	"./locked/kidnapped/description_en.md": 41823,
	"./locked/prison-break/description_da.md": 97073,
	"./locked/prison-break/description_en.md": 96744,
	"./locked/sabotage/description_da.md": 79813,
	"./locked/sabotage/description_en.md": 16221,
	"./locked/swat/description_da.md": 42196,
	"./locked/swat/description_en.md": 70480,
	"./locked/the-expedition/description_da.md": 91429,
	"./locked/the-expedition/description_en.md": 62757,
	"./locked/the-undead/description_da.md": 90030,
	"./locked/the-undead/description_en.md": 89220,
	"./locked/venue_da.md": 36906,
	"./locked/venue_en.md": 76987,
	"./middelaldercentret/the-lab/description_da.md": 78821,
	"./middelaldercentret/the-lab/description_en.md": 35535,
	"./middelaldercentret/the-secret-of-the-library/description_da.md": 45307,
	"./middelaldercentret/the-secret-of-the-library/description_en.md": 29182,
	"./middelaldercentret/venue_da.md": 31796,
	"./middelaldercentret/venue_en.md": 39493,
	"./midgaard-event/da-vinci/description_da.md": 22889,
	"./midgaard-event/da-vinci/description_en.md": 99706,
	"./midgaard-event/da-vinci/review_en.md": 63038,
	"./midgaard-event/downfall/description_da.md": 6656,
	"./midgaard-event/downfall/description_en.md": 47441,
	"./midgaard-event/outbreak/description_da.md": 66508,
	"./midgaard-event/outbreak/description_en.md": 75489,
	"./midgaard-event/sherlock/description_da.md": 28358,
	"./midgaard-event/sherlock/description_en.md": 11669,
	"./midgaard-event/sherlock/review_en.md": 63724,
	"./midgaard-event/venue_da.md": 50750,
	"./midgaard-event/venue_en.md": 27819,
	"./mosede-fort/the-angel-hunter/description_da.md": 73223,
	"./mosede-fort/the-angel-hunter/description_en.md": 84989,
	"./mosede-fort/venue_da.md": 63083,
	"./mosede-fort/venue_en.md": 67410,
	"./museum-obscurum/cornelius-secret/description_da.md": 15901,
	"./museum-obscurum/cornelius-secret/description_en.md": 41943,
	"./museum-obscurum/venue_da.md": 10598,
	"./museum-obscurum/venue_en.md": 15553,
	"./mystery-makers/the-killing-room/description_da.md": 23048,
	"./mystery-makers/the-killing-room/description_en.md": 48613,
	"./mystery-makers/the-lab/description_da.md": 73234,
	"./mystery-makers/the-lab/description_en.md": 38531,
	"./mystery-makers/the-ritual/description_da.md": 96353,
	"./mystery-makers/the-ritual/description_en.md": 17910,
	"./mystery-makers/the-ritual/review_en.md": 46706,
	"./mystery-makers/venue_da.md": 69204,
	"./mystery-makers/venue_en.md": 42936,
	"./nerd-cave/venue_da.md": 51717,
	"./nerd-cave/venue_en.md": 95501,
	"./once-upon-a-time/venue_da.md": 86066,
	"./once-upon-a-time/venue_en.md": 58285,
	"./penguin-escape/the-poachers-cabin/description_da.md": 74226,
	"./penguin-escape/the-poachers-cabin/description_en.md": 96897,
	"./penguin-escape/the-witchs-kitchen/description_da.md": 73782,
	"./penguin-escape/the-witchs-kitchen/description_en.md": 24524,
	"./penguin-escape/venue_da.md": 59500,
	"./penguin-escape/venue_en.md": 99040,
	"./play-time/escape-room-play-time/description_da.md": 62624,
	"./play-time/escape-room-play-time/description_en.md": 82472,
	"./play-time/venue_da.md": 2378,
	"./play-time/venue_en.md": 16213,
	"./questbox/questbox/description_da.md": 73483,
	"./questbox/questbox/description_en.md": 63140,
	"./questbox/venue_da.md": 51721,
	"./questbox/venue_en.md": 84382,
	"./riddle-house/pablo-escobar/description_da.md": 45523,
	"./riddle-house/pablo-escobar/description_en.md": 73917,
	"./riddle-house/professor-jones/description_da.md": 65552,
	"./riddle-house/professor-jones/description_en.md": 91315,
	"./riddle-house/ragnarok/description_da.md": 82882,
	"./riddle-house/ragnarok/description_en.md": 15206,
	"./riddle-house/seven/description_da.md": 40670,
	"./riddle-house/seven/description_en.md": 62367,
	"./riddle-house/seven/review_en.md": 97682,
	"./riddle-house/slaughterhouse/description_da.md": 1034,
	"./riddle-house/slaughterhouse/description_en.md": 10409,
	"./riddle-house/spymaster/description_da.md": 32827,
	"./riddle-house/spymaster/description_en.md": 87051,
	"./riddle-house/the-enigma-killer/description_da.md": 1547,
	"./riddle-house/the-enigma-killer/description_en.md": 63244,
	"./riddle-house/the-last-passenger/description_da.md": 52942,
	"./riddle-house/the-last-passenger/description_en.md": 72738,
	"./riddle-house/the-last-passenger/review_en.md": 51918,
	"./riddle-house/the-mystery-about-dannebroge/description_da.md": 16583,
	"./riddle-house/the-mystery-about-dannebroge/description_en.md": 22419,
	"./riddle-house/the-ring/description_da.md": 66855,
	"./riddle-house/the-ring/description_en.md": 91811,
	"./riddle-house/the-ring/review_en.md": 73329,
	"./riddle-house/the-witch/description_da.md": 91285,
	"./riddle-house/the-witch/description_en.md": 33239,
	"./riddle-house/venue_da.md": 95871,
	"./riddle-house/venue_en.md": 25886,
	"./riddle-room/the-childrens-room/description_da.md": 68725,
	"./riddle-room/the-childrens-room/description_en.md": 14471,
	"./riddle-room/venue_da.md": 27032,
	"./riddle-room/venue_en.md": 99452,
	"./royal-escapes/the-royal-dungeon/description_da.md": 9153,
	"./royal-escapes/the-royal-dungeon/description_en.md": 76234,
	"./royal-escapes/the-royal-mystery/description_da.md": 9137,
	"./royal-escapes/the-royal-mystery/description_en.md": 64487,
	"./royal-escapes/the-royal-playroom/description_da.md": 92729,
	"./royal-escapes/the-royal-playroom/description_en.md": 47517,
	"./royal-escapes/venue_da.md": 10484,
	"./royal-escapes/venue_en.md": 95598,
	"./rubilees-escape-house/1864-spy/description_da.md": 39755,
	"./rubilees-escape-house/1864-spy/description_en.md": 5567,
	"./rubilees-escape-house/academy-of-magic/description_da.md": 32122,
	"./rubilees-escape-house/academy-of-magic/description_en.md": 31782,
	"./rubilees-escape-house/venue_da.md": 58461,
	"./rubilees-escape-house/venue_en.md": 83596,
	"./secret-games/room-of-magic/description_da.md": 15944,
	"./secret-games/room-of-magic/description_en.md": 68938,
	"./secret-games/secret-casino/description_da.md": 57968,
	"./secret-games/secret-casino/description_en.md": 53119,
	"./secret-games/vampire-hunters/description_da.md": 22905,
	"./secret-games/vampire-hunters/description_en.md": 9027,
	"./secret-games/venue_da.md": 33392,
	"./secret-games/venue_en.md": 97439,
	"./timequest/alcatraz/description_da.md": 62476,
	"./timequest/alcatraz/description_en.md": 99506,
	"./timequest/follow-the-money/description_da.md": 91039,
	"./timequest/follow-the-money/description_en.md": 38354,
	"./timequest/follow-the-money/review_en.md": 38033,
	"./timequest/prison-break/description_da.md": 56349,
	"./timequest/prison-break/description_en.md": 16595,
	"./timequest/prison-break/review_en.md": 80729,
	"./timequest/the-bank/description_da.md": 1258,
	"./timequest/the-bank/description_en.md": 21713,
	"./timequest/the-bank/review_en.md": 35313,
	"./timequest/the-cube/description_da.md": 26761,
	"./timequest/the-cube/description_en.md": 46324,
	"./timequest/the-laboratory/description_da.md": 26694,
	"./timequest/the-laboratory/description_en.md": 12836,
	"./timequest/the-laboratory/review_en.md": 56088,
	"./timequest/the-olsen-gang/description_da.md": 28680,
	"./timequest/the-olsen-gang/description_en.md": 67849,
	"./timequest/venue_da.md": 45662,
	"./timequest/venue_en.md": 11712,
	"./vingsted/escape-house/description_da.md": 43046,
	"./vingsted/escape-house/description_en.md": 87439,
	"./vingsted/the-vikings-return/description_da.md": 70374,
	"./vingsted/the-vikings-return/description_en.md": 75583,
	"./vingsted/venue_da.md": 36749,
	"./vingsted/venue_en.md": 25490,
	"./wayout-copenhagen/casino/description_da.md": 89242,
	"./wayout-copenhagen/casino/description_en.md": 35046,
	"./wayout-copenhagen/mr-greys-room/description_da.md": 33926,
	"./wayout-copenhagen/mr-greys-room/description_en.md": 59803,
	"./wayout-copenhagen/taken/description_da.md": 14952,
	"./wayout-copenhagen/taken/description_en.md": 75676,
	"./wayout-copenhagen/venue_da.md": 87191,
	"./wayout-copenhagen/venue_en.md": 27513,
	"./zagadka/stalins-doctors/description_da.md": 71314,
	"./zagadka/stalins-doctors/description_en.md": 29609,
	"./zagadka/the-djatlov-mystery/description_da.md": 24350,
	"./zagadka/the-djatlov-mystery/description_en.md": 43315,
	"./zagadka/the-djatlov-mystery/review_en.md": 49938,
	"./zagadka/the-gulag-escape/description_da.md": 96785,
	"./zagadka/the-gulag-escape/description_en.md": 52611,
	"./zagadka/the-gulag-escape/review_en.md": 33246,
	"./zagadka/venue_da.md": 46882,
	"./zagadka/venue_en.md": 49326
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88382;